import * as types from './mutations-types'

export default {
  [types.UPDATE_CURRENT_NEWS_SORT_ID]: (state, currentSortId) => {
    console.log('UPDATE_CURRENT_NEWS_SORT_ID:' + currentSortId)
    state.currentSortId = currentSortId
  },
  [types.UPDATE_CURRENT_NEWS_SORT_NAME]: (state, currentSortName) => {
    state.currentSortName = currentSortName
  },
  [types.UPDATE_CURRENT_ROUTER_NAME]: (state, currentRouterName) => {
    state.currentRouterName = currentRouterName
  },
  [types.UPDATE_NEWS_SORTS]: (state, newsSorts) => {
    state.newsSorts = newsSorts
  },
  [types.UPDATE_VENUE_PAGE_TYPE]: (state, venuePageType) => {
    state.venuePageType = venuePageType
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js